export default __webpack_public_path__ + "static/roue-2f6b6e5be79509c1346e51a905b95b20.webp";